'use client';

import App from '../src/App';

export default function Home() {
  return <App />;
}
